import jsIcon from "../assets/js.png";
import reactIcon from "../assets/react.png";
import htmlIcon from "../assets/html.png";
import cssIcon from "../assets/css.png";
import nodeIcon from "../assets/node.png";
import expressIcon from "../assets/express.png";
import mongoIcon from "../assets/mongo.png";
import mysqlIcon from "../assets/mysql.png";
import vueIcon from "../assets/vue.png";
import customIcon from "../assets/custom.png";

export const categories = [
  {
    id: "javascript",
    name: "JavaScript",
    icon: jsIcon,
    description: "Adds interactivity & dynamic behaviour to web pages."
  },
  {
    id: "react",
    name: "React",
    icon: reactIcon,
    description: "Library for building fast, reusable , & interactive UI components."
  },
  {
    id: "html",
    name: "HTML",
    icon: htmlIcon,
    description: "Defines the structure & content of web pages.",
  },
  {
    id: "css",
    name: "CSS",
    icon: cssIcon,
    description: "Styles & layout for creating visually appealing designs.",
  },
    {
    id: "node",
    name: "Node",
    icon: nodeIcon,
    description: "JavaScript runtime for building fast, scalable backend.",
  },
    {
    id: "express",
    name: "Express",
    icon: expressIcon,
    description: "Minimal Node.js framework for creating robust web APIs.",
  },
    {
    id: "mongodb",
    name: "MongoDB",
    icon: mongoIcon,
    description: "NoSQL databse for flexible, document-based data storage.",
  },
    {
    id: "sql",
    name: "SQL",
    icon: mysqlIcon,
    description: "Relational database for structured data with SQL queries.",
  },
    {
    id: "vue",
    name: "Vue",
    icon: vueIcon,
    description: "Progressive JavaScript framework for dynamic user interface.",
  },
  {
  id: "custom",
  name: "Custom Quiz",
  icon: customIcon,
  description: "Personalized Quiz",
},

];
